import { FormattedMessage } from "react-intl";

import { useIsFeatureEnabled } from "@nens/ranalib";

export function useProcessesTabLabel() {
  // FUTURE: remove feature flag when workflows are released
  const workflowsEnabled = useIsFeatureEnabled("enableWorkflows");

  return workflowsEnabled ? (
    <FormattedMessage id="page_title.project.analysis_tools" defaultMessage="Analysis tools" />
  ) : (
    <FormattedMessage id="page_title.project.processes" defaultMessage="Processes" />
  );
}
